<script lang="ts">
    import $ from "jquery";
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { CriterionSelectorDialogViewModel } from "@Criteria/Hierarchies/Components/CriterionSelectorDialog";


    @Component({
        props: {
            viewModel: { type: Object, required: true }
        },
        watch: {
            opened: 'onOpenedChanged'
        }
    })
    export default class CriterionSelectorDialog extends Vue
    {
        get vm(): CriterionSelectorDialogViewModel { return this.$props.viewModel as CriterionSelectorDialogViewModel; }

        get opened(): boolean { return this.vm?.opened ?? false; }

        //@Watch('vm.opened')
        onOpenedChanged(val: boolean, oldVal: boolean)
        {
            if (val === true)
            {
                const vms: CriterionVM[] = this.vm.criteria.map(c => new CriterionVM(c));
                vms.forEach(vm => { vm.Subcriteria = vms.filter(b => b.ParentId === vm.Id); });
                const goal = vms.find(a => a.ParentId == null);

                Vue.nextTick(() =>
                {
                    $("#treeview").kendoTreeView({
                        dataSource: new kendo.data.HierarchicalDataSource({
                            data: [goal],
                            schema: {
                                model: {
                                    id: "Id",
                                    children: "Subcriteria",
                                },
                            }
                        }),
                        dataTextField: "Name",
                        loadOnDemand: false,
                    });

                    const treeview = $("#treeview").data("kendoTreeView");
                    treeview.expand(".k-item");
                    const item = treeview.dataSource.get(this.vm.selectedCriterionId)
                    treeview.select(treeview.findByUid(item.uid));
                });
            }
        }

        confirm()
        {
            const tv = $("#treeview").data("kendoTreeView");
            var selectedNode = tv.select();
            var item = tv.dataItem(selectedNode);

            this.$emit('confirm-selection', item.id);
            this.close();
        } 

        close()
        {
            this.vm.close();
        }
    }

    class CriterionVM
    {
        Id: number;
        ParentId: number;
        Name: string;
        Subcriteria: CriterionVM[] = [];

        constructor(c: { Id: number, ParentId: number, Name: string })
        {
            this.Id = c.Id;
            this.ParentId = c.ParentId;
            this.Name = c.Name;
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Select a criterion</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div id="treeview"></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Close</button>
                        <button type="button" @click="confirm" class="btn btn-success">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>